import React from "react";
import FormSelect from "../../../components/UI/formSelect/formSelect";
import Input from "../../../components/UI/input/GgInput";
import FileButton from "../../../components/UI/button/FileButton";
import { AddIcon } from "../../../assets/icons";
import { IContent, IPMBlock } from "../../../models/IPages";
import { getImageExtensionFromBase64 } from "../../../utils";

function ArticlesBlock({ data, setData, articles, categoryType, actionData }: IPMBlock) {
  const handleArticlesBlock = (
    index: number,
    val: string,
    type: keyof IContent
  ) =>
    setData((prev: any) => {
      const newContent = [...prev.content];
      newContent[index][type] = val;
      if (type === "image") {
        const newImages = prev.images || [];
        newImages[index] = val;
        const ext = getImageExtensionFromBase64(val);
        newContent[index][
          "image"
        ] = `/image/page-management/${categoryType}/articlesBlock${index + 1}.${
          ext || "jpeg"
        }`;
        return { ...prev, images: newImages, content: newContent };
      }
      return { ...prev, content: newContent };
    });

  return (
    <>
      <div className="title">Articles Block</div>
      <div className="step-list col">
        <div className="step-item">
          <div className="step-title">Title</div>
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-list">
          <div className="step-item">
            <div className="step-title">Start Application Button <span style={{color:'gray'}}>(Enter page link)</span></div>
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter link"
                value={data?.startAppBtn}
                onChange={(val) => setData({ ...data, startAppBtn: val })}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="step-title">Learn more Button <span style={{color:'gray'}}>(Enter page link)</span></div>
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter link"
                value={data?.learnMoreBtn}
                onChange={(val) => setData({ ...data, learnMoreBtn: val })}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
        </div>
        <div className="card-container">
          {[1, 2, 3].map((item: any, index: any) => {
            return (
              <div key={index} className="card">
                <FileButton
                  index={index}
                  icon={{
                    leftIcon: <AddIcon size="18" className="icon" />,
                  }}
                  value={data?.content[index].image}
                  stylesType="border"
                  onChange={(val) => handleArticlesBlock(index, val, "image")}
                  className="cover-image-button"
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter title"
                  value={data?.content[index].heading}
                  onChange={(val) => handleArticlesBlock(index, val, "heading")}
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter description"
                  value={data?.content[index].description}
                  onChange={(val) =>
                    handleArticlesBlock(index, val, "description")
                  }
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter link"
                  value={data?.content[index].link}
                  onChange={(val) => handleArticlesBlock(index, val, "link")}
                  disabled={!actionData?.edit}
                />
                {/* <FormSelect
                  list={articles}
                  defaultValue={data?.content[index].link}
                  label="Page link"
                  onChange={(val) =>
                    handleArticlesBlock(index, val.value, "link")
                  }
                /> */}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ArticlesBlock;
